import React from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import SearchComponent from './utils/SearchComponent';
import ReferEarnTable from './table';

import {
  getAllUsers,
  getDefaultReferralAmount,
  updateDefaultReferralAmount,
} from '../../services/apiService';
import LoadingCircleIcon from '../../icons/LoadingCircle';

import AddReferrer from './utils/addRefer';
import { PageHeader } from '../../extras/PageLayout';

function ReferEarn() {
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [users, setUsers] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [referrer, setReferrer] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [defaultReferralAmount, setDefaultReferralAmount] =
    React.useState(false);

  const handleAddReferrer = () => {
    setReferrer(true);
  };

  React.useState(() => {
    const loadDefaultReferralAmount = async () => {
      try {
        const res = await getDefaultReferralAmount();
        setDefaultReferralAmount(res.defaultReferralAmount);
      } catch (e) {
        console.error(e);
        toast.error('Failed to fetch Default Referral Amount');
      }
    };

    loadDefaultReferralAmount();
  }, []);

  const handleUpdateDefaultReferralAmount = async () => {
    setUpdating(true);
    try {
      await updateDefaultReferralAmount({ defaultReferralAmount });
      toast.info('Updated!');
    } catch (err) {
      console.error(err);
      toast.error('Failed to update!');
    }
    setUpdating(false);
  };

  return (
    <>
      <PageHeader
        title="Tiny Url (Refer and Earn)"
        subtitle="Manage referral programs and referrers"
      />
      <div className='mt-8 flex justify-between'>
          <div
            style={{
              width: 280,
            }}
          >
            <SearchComponent
              required
              value={selectedUser || ''}
              setValue={(user) => setSelectedUser(user)}
              searchApi={getAllUsers}
              responseKey='users'
              setUsers={setUsers}
              placeholder='Search name / email id'
              setLoader={setLoading}
            />
          </div>

          <div className='flex gap-4'>
            <TextField
              value={defaultReferralAmount}
              onChange={(e) => setDefaultReferralAmount(Number(e.target.value))}
              variant='outlined'
              type='number'
              label='Default Referral Amount'
              fullWidth
              InputProps={{
                endAdornment: (
                  <button
                    onClick={handleUpdateDefaultReferralAmount}
                    className='bg-blue-c1 text-white px-4 py-2 rounded flex'
                  >
                    {updating ? (
                      <CircularProgress color='inherit' size={18} />
                    ) : (
                      'Update'
                    )}
                  </button>
                ),
              }}
            />
          </div>

          <div className='mr-0.5 flex items-center'>
            <div
              className='border-2 rounded px-4 py-2 cursor-pointer font-medium text-blue-c1 border-blue-c1'
              onClick={handleAddReferrer}
            >
              <span className='rounded-lg px-1.5 mr-1 border-2 border-blue-c1'>
                +
              </span>
              add referrer
            </div>
          </div>
        </div>
        {loading && (
          <div className='w-full text-center'>
            <LoadingCircleIcon iconStyle='w-20 h-20 absolute m-auto left-12 right-0 top-1/2 z-50' />
          </div>
        )}
        <div className='ag-theme-alpine h-screen mt-4 mx-0.5'>
          <ReferEarnTable rowData={users} />
        </div>
        <AddReferrer
          edit={referrer}
          setEdit={setReferrer}
          heading='Add New Referrer'
          params={{}}
        />
    </>
  );
}

export default ReferEarn;
